import api from '../../../services/api'

export const getCurrentLegalDocument = documentType => api.get(
  `/legal-documents/types/${documentType}/current`,
)

export const getLegalDocumentHistoryHeaders = documentType => api.get(
  `/legal-documents/types/${documentType}/history/headers`,
)

export const getLegalDocument = legalDocumentId => api.get(
  `/legal-documents/${legalDocumentId}`,
)

export const getCurrentLegalDocumentHeaders = actionContext => api.get(
  `/legal-documents/action-contexts/${actionContext}/current/headers`,
)

export const getCurrentLegalDocumentActionStatuses = actionContext => api.get(
  `/legal-documents/action-contexts/${actionContext}/current/action-statuses`,
)

export const recordLegalDocumentActions = (actionContext, payload) => api.post(
  `/legal-documents/action-contexts/${actionContext}/actions`,
  payload,
)
